import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import securePersist from '@/utils/securePersist';

export interface User {
  id?: number | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  registration_state?: string | null;
}

interface UserStore {
  user: User;
  setUserData: (user: User) => void;
  clearUserData: () => void;
  getUserType: () => 'prospect' | 'patient';
}

export const userStore = create<UserStore>()(
  devtools(
    securePersist(
      (set, get) => ({
        user: {
          id: null,
          email: null,
          firstName: null,
          lastName: null,
          registration_state: null,
        },
        setUserData: (user) => set({ user }),
        clearUserData: () =>
          set({
            user: {
              id: null,
              email: null,
              firstName: null,
              lastName: null,
              registration_state: null,
            },
          }),
        getUserType: () => (get().user.registration_state === 'completed' ? 'patient' : 'prospect'),
      }),
      { name: 'user-store' },
    ),
  ),
);
